import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element
      .querySelectorAll("a.active")
      .forEach((link) => link.classList.remove("active"));

    const currentPath = window.location.pathname;
    let activeLink = this.findBestMatch(currentPath);

    if (activeLink) {
      activeLink.classList.add("active");
    }
  }

  highlight(event) {
    let activeLink = this.element.querySelector("a.active");
    if (activeLink) {
      activeLink.classList.remove("active");
    }
    event.target.classList.add("active");
  }

  findBestMatch(currentPath) {
    // First try exact match
    let exactMatch = this.element.querySelector(`a[href='${currentPath}']`);
    if (exactMatch) {
      return exactMatch;
    }

    // Get all links and find the best partial match
    const allLinks = this.element.querySelectorAll("a[href]");
    let bestMatch = null;
    let longestMatch = 0;

    allLinks.forEach((link) => {
      const href = link.getAttribute("href");

      // Skip empty hrefs
      if (!href) return;

      // Handle root path specially - only match if current path is exactly root
      if (href === "/" && currentPath !== "/") {
        return;
      }

      // For non-root paths, check if current path starts with href
      if (href !== "/" && currentPath.startsWith(href)) {
        // Make sure we're matching on path boundaries to avoid partial matches
        // e.g., /leads should not match /leads-something
        const nextChar = currentPath.charAt(href.length);
        if (
          nextChar === "" ||
          nextChar === "/" ||
          nextChar === "?" ||
          nextChar === "#"
        ) {
          if (href.length > longestMatch) {
            longestMatch = href.length;
            bestMatch = link;
          }
        }
      }

      // Exact match for root
      if (href === "/" && currentPath === "/") {
        bestMatch = link;
      }
    });

    // If no good match found, fallback to old behavior for backward compatibility
    if (!bestMatch && currentPath !== "/") {
      bestMatch = this.element.querySelector(
        "a[href^='" + currentPath.slice(0, 3) + "']",
      );
    }

    return bestMatch;
  }
}
